<template>
  <div class="materials-form">
    <img
      src="/img/materials/form-bg.webp"
      alt="background"
      class="materials-form__image"
    >

    <h4 class="materials-form__title">
      Запишитесь на консультацию с&nbsp;куратором и&nbsp;получите
      <span>бесплатно</span> на&nbsp;выбор:
    </h4>

    <ul class="materials-form__list">
      <li>Доступ к платформе <br>онлайн-школы <span class="no-tablet">на 7 дней</span></li>
      <li>1 пробный день <br> в онлайн-школе</li>
      <li>1 урок с репетитором <br><span class="no-tablet">по любому предмету</span></li>
      <li>Диагностику гибких <br>навыков у ребенка</li>
    </ul>

    <div class="materials-form__inputs">
      <form-name-field
        ref="nameField"
        v-model="nameInput"
        class="materials-form__inputs_input materials-form__inputs_name"
        placeholder="Имя"
        error-message="Введите имя*"
      />

      <form-phone-field
        ref="phoneField"
        class="materials-form__inputs_input materials-form__inputs_phone"
        :errors-list="submitError"
        :error="validForm === false"
        error-message="Введите телефон*"
        @updatePhone="phoneInput = $event"
      />

      <form-email-field
        ref="emailField"
        v-model="emailInput"
        class="materials-form__inputs_input materials-form__inputs_email"
        :submit-error="submitError"
        placeholder="Почта"
        error-message="Введите почту*"
        @clearSubmitError="clearSubmitError"
      />

      <button
        class="m-btn materials-form__inputs_button"
        @click="submit"
      >
        Записаться
        <img
          src="/v2/soft-skills/form/arrow.svg"
          alt="arrow"
        >
      </button>
    </div>

    <p class="materials-form__law">
      Нажимая на кнопку, вы соглашаетесь
      <nuxt-link
        to="/privacy"
        target="_blank"
      >
        на условия обработки данных
      </nuxt-link>
    </p>
  </div>
</template>

<script>
import FormNameField from '~/components/v2/common/fileds/FormNameField.vue';
import FormPhoneField from '~/components/v2/common/fileds/FormPhoneField.vue';
import FormEmailField from '~/components/v2/common/fileds/FormEmailField.vue';
import sendLeadMixinConstructor from '~/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needName: true,
  needPhone: true,
  needEmail: true,
});

export default {
  name: 'MaterialsBottomForm',
  components: {
    FormNameField,
    FormPhoneField,
    FormEmailField,
  },
  mixins: [sendLeadMixin],
  data: () => ({
    landCode: 'new_school_blog',
  }),
};
</script>

<style lang="scss" scoped>

.materials-form {
  width: min(calc(100% - 22px), 1168px);
  margin: 66px auto 0;
  padding: 32px 24px 22px;

  position: relative;

  border-radius: 32px;
  box-shadow: 0 16px 64px 0 rgba(15, 15, 15, 0.06);

  background-color: $white-color;
  background-image: url("/v2/common/grid.svg");
  background-position: center;
  background-size: 1100px;
  background-repeat: repeat;

  font-family: 'TildaSans', sans-serif;

  @include media-down(laptop) {
    padding: 32px 16px 40px;
  }

  @include media-down(tablet) {
    margin-top: 10px;
  }

  .materials-form__title {
    max-width: 720px;
    margin-bottom: 30px;

    color: $black;
    font-size: 32px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.96px;

    @include media-up(laptop) {
      margin-left: 8px;
    }

    @include media-down(tablet) {
      margin-bottom: 24px;
      font-size: 20px;
      letter-spacing: 0;
    }

    span {
      color: $orange-color;
    }
  }

  .materials-form__list {
    max-width: 550px;
    margin-bottom: 30px;

    display: flex;
    flex-wrap: wrap;
    gap: 20px 38px;

    @include media-up(laptop) {
      margin-left: 8px;
    }

    @include media-down(tablet) {
      max-width: 400px;
      margin-bottom: 24px;

      gap: 16px;
    }

    li {
      width: 240px;
      padding-left: 22px;
      position: relative;

      color: $black;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 18px;
      font-weight: 500;
      line-height: 130%;
      letter-spacing: -0.18px;

      @include media-down(tablet) {
        width: 160px;

        font-size: 14px;
        letter-spacing: -0.14px;
      }

      &::before {
        content: '';
        display: block;
        width: 14px;
        height: 100%;

        position: absolute;
        left: 0;

        background-image: url("/img/materials/form-point.svg");
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }

  .materials-form__inputs {
    margin-bottom: 15px;
    position: relative;
    display: flex;
    gap: 10px;

    @include media-down(laptop) {
      margin-bottom: 14px;
      flex-wrap: wrap;
    }

    .materials-form__inputs_input {
      width: 25%;

      @include media-down(laptop) {
        width: calc(50% - 5px);
      }

      @include media-down(tablet) {
        width: 100%;
      }
    }

    ::v-deep .phone-field__wrap {
      height: 70px;
      border: none;
      border-radius: 0;
      background-color: transparent;

      &.phone-field__wrap--error input {
        border-color: #ff0040;
      }
    }

    ::v-deep input {
      height: 70px;
      width: 100%;

      border-radius: 20px;
      border: 2px solid $grey-select;
      background-color: $white-color;

      color: $black;
      font-size: 20px;
      letter-spacing: 0.4px;

      &::placeholder {
        color: #919191;
      }
    }

    ::v-deep .error-message {
      border-radius: 5px;
    }

    .materials-form__inputs_button {
      width: 25%;
      height: 70px;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;

      border: none;
      border-radius: 20px;
      background-color: $orange-color;

      color: $black;
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 20px;
      font-weight: 700;

      @include media-down(laptop) {
        width: calc(50% - 5px);
      }

      @include media-down(tablet) {
        width: 100%;
      }

      img {
        transform: translateY(-4px);
      }
    }
  }

  .materials-form__law {
    position: relative;

    color: $gray-color;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 18px;
    font-weight: 500;
    line-height: 100%;

    @include media-down(tablet) {
      font-size: 14px;

      a {
        display: block;
      }
    }
  }

  .materials-form__image {
    height: 388px;
    position: absolute;
    right: 0;
    bottom: 0;

    @include media-down(laptop) {
      display: none;
    }
  }
}

</style>
